import React, { useEffect, useRef, useState } from 'react';
import honeyComb from '../../media/img/honeycomb.svg';

import { Link } from 'react-router-dom';
const parallaxLayers = [
  { className: 'large-orange-hex', speed: 0.4 },
  { className: 'med-orange-hex-one', speed: 0.6 },
  { className: 'med-orange-hex-two', speed: 0.1 },
  { className: 'med-dark-hex', speed: 0.5 },
  { className: 'small-solid-orange-hex-one', speed: 2 },
  { className: 'small-solid-orange-hex-two', speed: -0.8 },
  { className: 'large-dark-blur-hex', speed: 1.8 },
  { className: 'ds-code-logo', speed: 0.3}
];
const MAX_X = 0;          // starting position
const MIN_X = -450;      // how far left before fully shrunk
const MAX_SCALE = 1;
const MIN_SCALE = 0.2;

const lerp = (value, min, max) =>
  Math.min(Math.max(value, min), max);

export default function HeroBanner({ setHeroHeight }) {
  const bannerRef = useRef(null);
  const [cursorVisible, setCursorVisible] = useState(false);

  useEffect(() => {
const handleScroll = () => {
  const scrollTop = window.pageYOffset;
  
  parallaxLayers.forEach(({ className, speed }) => {
    const layer = document.querySelector(`.${className}`);
    if (!layer) return;

    const yPos = -(scrollTop * speed);

    if (className === "ds-code-logo") {
      // Special logic for the logo (X-axis and Scaling)
      const xPos = yPos; 
      const clampedX = lerp(xPos, MIN_X, MAX_X);
      const t = (clampedX - MAX_X) / (MIN_X - MAX_X);
      const scale = MAX_SCALE - t * (MAX_SCALE - MIN_SCALE);

      layer.style.transform = `translate(${xPos}px, ${yPos - 50}px) scale(${scale})`;
    } else {
      // ✅ Standard movement for all other hexagons
      layer.style.transform = `translateY(${yPos}px)`;
    }
  });
};

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const updateHeight = () => {
      if (bannerRef.current) {
        setHeroHeight(bannerRef.current.offsetHeight);
      }
    };

    updateHeight(); // on mount
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, [setHeroHeight]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCursorVisible(prev => !prev);
    }, 400);
    return () => clearInterval(interval);
  }, []);

  return (
    <header ref={bannerRef} id="page-top" className="f-col no-select">
      <img src={honeyComb} className="hero-banner" alt="hero background" />
      <h3 className="z100 tagline">
        Writing Thoughts into Reality
        <span className={`cursor ${cursorVisible ? 'visible' : ''}`}>|</span>
      </h3>

      {parallaxLayers.map(({ className }) => (
        <div key={className} className={`parallax ${className} z${className.includes('dark') ? 7 : 4}`}></div>
      ))}

      {/* <div className="btn-wrapper f-col center">
        <Link to="/portfolio" className="btn">See my work</Link>
        <a href="https://theForks.io" target="_blank" rel="noopener noreferrer" className="btn secondary">Check out theForks.io</a>
      </div> */}
    </header>
  );
}
